import { Component, Inject, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SHARED_IMPORTS } from '../../shared/shared-imports';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { PermissionService } from '../../../services/permission.service';
import { OrderObjectByPipe } from '../../../pipes/order-object-by.pipe';
import './global-main.component.css'

interface Tenant {
	TenantId: string;
	TenantName: string;
}

interface LogLevel {
	Name: string;
	DisplayName: string;
	Value: number;
}

interface NewTenantForm {
	TenantName?: string;
	TenantAdminEmail?: string;
	TenantAdminAuth0Id?: string;
}

@Component({
	selector: 'global-main',
	standalone: true,
	imports: [
		...SHARED_IMPORTS,
		MatButtonModule,
		MatSelectModule,
		MatInputModule,
		MatFormFieldModule,
		ConfirmDialogComponent,
		OrderObjectByPipe
	],
	templateUrl: 'components/global-admin/global-main/global-main.component.html',
	styleUrls: ['components/global-admin/global-main/global-main.component.css'],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class GlobalMainComponent implements OnInit {
	public tenants: Tenant[] = [];
	public loglevels: LogLevel[] = [];
	public currentLogLevel: string = '';
	public newTenantForm: NewTenantForm = {};
	public sqlQuery: string = '';
	public table: any[] = [];
	public setHomeTenantModel: string = '';
	public setDefaultHomeTenantModel: string = '';
	public selectedTenant: string = '';

	// Test form properties
	public smsTestPhone: string = '';
	public emailTestEmail: string = '';
	public CreateSCErrorTestUnitId: string = 'cfab22e4-63bc-4f8d-8250-1304ce7cd2a1';
	public CreateSCMeasurementTestUnitId: string = 'cfab22e4-63bc-4f8d-8250-1304ce7cd2a1';
	public CreateNotificationTestType: string = '1';
	public CreateNotificationTestMessage: string = '';
	public SendAlarmId: string = '00000000-0000-0000-0000-000000000001';
	public InAppNotificationTestUserId: string = '00000000-0000-0000-0000-000000000000';
	public InAppNotificationTestMessageText: string = 'This is the text message';
	public contentId: string = '';
	public contentValue: string = '';

	private ref: Window | null = null;

	constructor(
		@Inject(HttpClient) private http: HttpClient,
		@Inject(MatDialog) private dialog: MatDialog,
		@Inject(PermissionService) private permissionService: PermissionService
	) { }

	ngOnInit(): void {
		this.permissionService.getPermissions().then((permissions: any) => {
			if (permissions !== null) {
			}
		});

		this.http.get<Tenant[]>("/api/prototype/tenants").subscribe((tenants) => {
			this.tenants = tenants;
		});

		this.http.get<LogLevel[]>("/api/prototype/loglevels").subscribe((loglevels) => {
			this.loglevels = loglevels;
		});

		this.http.get<string>("/api/prototype/currentloglevel").subscribe((currentLogLevel) => {
			this.currentLogLevel = currentLogLevel;
		});
	}

	public callRestSave(url: string): void {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			data: {
				title: 'Are you sure you want to run this URL? ' + url,
				okText: 'Yes',
				cancelText: 'No'
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.callRest(url);
			}
		});
	}

	public callRest(url: string): void {
		if (this.ref) this.ref.document.close();
		this.http.get(url).subscribe((response) => {
			this.showResponseInPopup(response);
		});
	}

	public createTenant(): void {
		if (this.ref) this.ref.document.close();
		this.http.post('api/Prototype/CreateTenant', this.newTenantForm).subscribe((response) => {
			this.showResponseInPopup(response);
		});
	}

	public submitSqlQuery(): void {
		this.http
			.get<any>('api/Prototype/SqlQuery?sql=' + this.sqlQuery)
			.subscribe((response) => {
				this.table = response.Table;
			});
	}

	public setCurrentLogLevel(): void {
		this.http.get('/api/Prototype/setCurrentLogLevel/' + this.currentLogLevel).subscribe();
	}

	public setHomeTenant(): void {
		this.http
			.post('/api/Tenant/SetHomeTenant?tenantName=' + this.setHomeTenantModel, {})
			.subscribe(() => { });
		this.toggleVisibility('setHomeTenantId');
	}

	public setDefaultHomeTenant(): void {
		this.http
			.post('/api/Tenant/SetDefaultHomeTenant?tenantName=' + this.setDefaultHomeTenantModel, {})
			.subscribe(() => { });
		this.toggleVisibility('setDefaultHomeTenantId');
	}

	private showResponseInPopup(response: any): void {
		this.ref = window.open('', 'GlobalAdminResponse');
		if (!this.ref) return;
		this.ref.document.write(`
      <html><head><title>GlobalAdmin response</title></head><body><pre>
      ${JSON.stringify(response, null, 2)}
      </pre></body></html>
    `);
	}

	private toggleVisibility(elementId: string): void {
		const el = document.getElementById(elementId);
		if (el) {
			el.classList.remove('hideDiv');
			el.classList.add('visibleClass');
		}
	}

	public showHide(id: string): boolean {
		const divToShow = document.getElementById(id);
		const divsToHide = document.getElementsByClassName("hideDiv");

		if (divToShow && divsToHide) {
			for (let i = 0; i < divsToHide.length; i++) {
				const el = divsToHide[i] as HTMLElement;
				el.style.display = "none";
			}
			divToShow.style.display = "block";
		}

		return false;
	}

	public getTableHeaders(): string[] {
		if (this.table.length === 0) return [];
		return Object.keys(this.table[0]);
	}

	public getRowValues(row: any): any[] {
		return Object.values(row);
	}
}
